<template>
  <div class="content">
    <h2 class='setpwd-title'>账户设置
      <el-button class="mt-10 authorize"  @click='authorization()' size="small">新增</el-button>
    </h2>

    <el-table 
      :data="tableData">
      <el-table-column 
        prop="wxServiceName" 
        label="公众号名称">
      </el-table-column>
      <el-table-column 
        prop="appid" 
        label="AppId">
      </el-table-column>
      <el-table-column 
        label="微信支付配置"
        width="150">
        <template slot-scope="scope">
          
          <el-button v-if="scope.row.appid === 'wxefcb58edf8136c78'" size="mini" type="text" style="color: #dddddd;font-weight: normal;">已配置</el-button>
          <el-button v-if="scope.row.paymentStatus === 1 && scope.row.appid !== 'wxefcb58edf8136c78'" size="mini" type="text" @click="setting(scope.row)" style="color: #65CC5F;font-weight: normal;">已配置</el-button>
          <el-button v-if="scope.row.paymentStatus === 0 && scope.row.appid !== 'wxefcb58edf8136c78'" size="mini" type="text" @click="setting(scope.row)">配置</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="新增"
      append-to-body
      :visible.sync="dialogShow"
      width="80%">
      <div class="center">
        <iframe style="width:100%;height:600px;" :src='wxAutoUrl' ></iframe>
      </div>
    </el-dialog>

    <el-dialog
      title="配置"
      append-to-body
      :before-close="handleClose"
      :visible.sync="dialogPayShow"
      width="40%">
      <WechatPay
        @OnSuccess='OnSuccess'
        :propsWxpayData='wxpayData'>
      </WechatPay>
    </el-dialog>
    
  </div>
</template>

<script>
  import Vue from 'vue';
  import { getToken } from '@/utils/cookie';
  import WechatPay from '@/views/wechat/wechatPay';

  export default {
    name: 'Authorize',
    components: {
      WechatPay
    },
    props: {
      isOpen: false
    },
    data() {
      return {
        wxAutoUrl: '',
        dialogShow: false,
        dialogPayShow: false,
        wxpayData: '',
        tableData: []
      }
    },
    created() {
      let urlparam = ''
      if(process.env.NODE_ENV === 'production') {
        urlparam = 'http://api.2gdt.com/wxopen/startauth?appid=wx2ed81a3d357491ef&domain=IMC&xtoken=' + getToken()
        this.wxAutoUrl = 'http://api.2gdt.com/common/iframe/wxauth.html?url=' + encodeURIComponent(urlparam)
      } else {
        urlparam = 'http://api.cn.1gdt.com/wxopen/startauth?appid=wxcf890409ee20b577&domain=IMC&xtoken=' + getToken()
        this.wxAutoUrl = 'http://api.cn.1gdt.com/common/iframe/wxauth.html?url=' + encodeURIComponent(urlparam)
      }
      this.wxserviceList();
    },
    watch: {
      isOpen(){
        this.wxserviceList();
      }
    },
    methods: {
      wxserviceList(){
        this.$store.dispatch("wxserviceList").then((res) => {
          this.tableData = res.wxServices
        });
      },
      authorization(){
        this.dialogShow = true;
      },
      // 配置
      setting(row){
        this.dialogPayShow = true;
        this.wxpayData = row;
      },
      handleClose(done) {
        done();
        this.wxpayData = ''
        this.wxserviceList()
      },
      OnSuccess() {
        this.dialogPayShow = false;
        this.wxserviceList()
      }
    }
  }
</script>
<style scoped>
  .content {
    padding: 20px;
  }
  .mt-10 {
    margin: 10px 0;
  }
  .authorize {
    float: right;
  }
  .setpwd-title {
    text-align: center;
    font-size: 18px;
    color:rgba(54,61,177,1);
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// authorize.vue?75775352